package com.tovtalk.domain.entity

/**
 * Result of getSuggestedArtists with pagination info.
 */
data class SuggestedArtistsResult(
    val list: List<User>,
    val hasMore: Boolean
)
